<template>
  <div class="col-12 page_content_area">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-10 col-xl-8">
          <navigation
            :list="lastFiveYears"
            :active-value="activeYear"
            variety="underline"
            @active:updated="updateActiveYear"
          />
        </div>
      </div>
      <div class="career_counselling_content_area row">
        <div
          v-if="counselorsGetter.length"
          class="col-12"
        >
          <career-counselling-card
            v-for="counselor in counselorsGetter"
            :key="`${careerCounselorsType}-${counselor.counselor_id}`"
            :counselor="counselor"
            :counselor-type="counselorsType"
            :title-ch="titleCh"
            :title-en="titleEn"
          />
        </div>
        <div
          v-else
          class="col-12 text-center"
        >
          尚未安排諮詢時程
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <bootstrap-pagination
            v-if="pageGetter.page_total > 1"
            :total-page-number="pageGetter.page_total"
            @number:updated="updateCounsellingPage"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { lastFiveYearsStartFrom2019, thisYearNumber } from '~utils/date-time'
import CareerCounsellingCard from './CareerCounsellingCard'
import BootstrapPagination from '~bootstrap/Pagination'
import Navigation from '~components/common/Navigation'
export default {
  name: 'CareerCounsellingIndexContent',
  components: {
    CareerCounsellingCard,
    BootstrapPagination,
    Navigation
  },
  props: {
    careerCounselorsType: {
      type: String,
      default: ''
    },
    titleCh: {
      type: String,
      default: ''
    },
    titleEn: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      lastFiveYears: lastFiveYearsStartFrom2019(),
      activeYear: thisYearNumber,
      counselorsType: 'career-counselors'
    }
  },
  computed: {
    ...mapGetters('pages/career-counselling', [
      'pageGetter',
      'counselorsGetter',
      'servicesGetter'
    ])
  },
  async created () {
    // await this.getAllCareerCounselors()
    // await this.getAllCareerCounselorServices()
    if (this.careerCounselorsType === '職涯諮詢師') {
      await this.getAllCareerCounselors({
        year: this.activeYear
      })
      await this.getAllCareerCounselorServices()
      this.counselorsType = 'career-counselors'
    } else {
      await this.getAllIndustryMentors({
        year: this.activeYear
      })
      await this.getAllIndustryMentorServices()
      this.counselorsType = 'industry-mentors'
    }
  },
  methods: {
    ...mapActions('pages/career-counselling', [
      'getAllCareerCounselors',
      'getAllIndustryMentors',
      'getAllCareerCounselorServices',
      'getAllIndustryMentorServices'
    ]),
    async updateActiveYear (year) {
      if (year) {
        this.activeYear = year
        if (this.careerCounselorsType === '職涯諮詢師') {
          await this.getAllCareerCounselors({
            year
          })
        } else {
          await this.getAllIndustryMentors({
            year
          })
        }
      }
    },
    async updateCounsellingPage (page) {
      if (this.careerCounselorsType === '職涯諮詢師') {
        await this.getAllCareerCounselors({
          page
        })
      } else {
        await this.getAllIndustryMentors({
          page
        })
      }
    }
  }
}
</script>
